import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const clientDosemeterMeasurementApi = createApi({
  reducerPath: "clientDosemeterMeasurement",
  refetchOnFocus: true,
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: window.location.origin,
    withCredentials: true
  }),
  endpoints: build => ({
    getNewDosemeter: build.query({
      query: newDosemeterRequest => ({
        url: '/api/ClientDosemeter/New',
        method: 'POST',
        body: newDosemeterRequest
      })
    }),
    addDosemeter: build.mutation({
      query: dosemeter => ({
        url: '/api/ClientDosemeter/',
        method: 'POST',
        body: dosemeter
      }),
      invalidatesTags: ['Measurements']
    }),
    getMeasurements: build.query({
      query: searchCriteria => ({
        url: '/api/ClientDosemeterMeasurement/Search',
        method: 'POST',
        body: searchCriteria
      }),
      providesTags: ['Measurements']
    }),
    markMeasurementAsResigned: build.mutation({
      query: measurementId => ({
        url: `/api/ClientDosemeterMeasurement/${measurementId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Measurements']
    }),
    markMeasurementDosemeterAsSent: build.mutation({
      query: measurement => ({
        url: '/api/ClientDosemeterMeasurement/DosemeterSent',
        method: 'POST',
        body: measurement
      }),
      invalidatesTags: ['Measurements']
    }),
    importMeasurementResults: build.mutation({
      query: measurementResults => ({
        url: '/api/ClientDosemeterMeasurement/ImportMeasurementResults',
        method: 'POST',
        body: measurementResults,
        formData: true
      }),
      invalidatesTags: ['Measurements', 'MeasurementReports']
    }),
    getMeasurementReports: build.query({
      query: searchCriteria => ({
        url: '/api/ClientDosemeterMeasurementReport/Search',
        method: 'POST',
        body: searchCriteria
      }),
      providesTags: ['MeasurementReports']
    }),
    downloadMeasurementReports: build.mutation({
      query: measurementReport => ({
        url: '/api/ClientDosemeterMeasurementReport/Download/' + measurementReport.clientDosemeterMeasurementReportId,
        method: 'GET',
        responseHandler: async (response) => {
          const responseData = await response.blob();
          const href = URL.createObjectURL(responseData);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', measurementReport.clientDosemeterMeasurementReportNumber + '.pdf');
          document.body.appendChild(link);
          link.click();

          // cleanup
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          
          return { data: null }
        }
      })
    })
  }),
  tagTypes: ['Measurements', 'MeasurementReports']
})

export const { useGetNewDosemeterQuery, useAddDosemeterMutation, useGetMeasurementsQuery, useMarkMeasurementAsResignedMutation, useMarkMeasurementDosemeterAsSentMutation, useImportMeasurementResultsMutation, useGetMeasurementReportsQuery, useDownloadMeasurementReportsMutation } = clientDosemeterMeasurementApi
